<template>
  <div class="baseLayout">
    <div class="baseLayout__top">
      <slot name="header"></slot>
    </div>
    <div class="baseLayout__bottom">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseLayout"
};
</script>

<style lang="less" scoped>
.baseLayout {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  .baseLayout__top {
    clear: both;
  }
  .baseLayout__bottom {
    position: relative;
    z-index: 1;
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
